import { isNetworkError } from "../../helpers/networkErrors";

/**
 * Wrapper that catches network errors silently.
 * Network errors are already handled by useApiClient (shows offline dialog).
 *
 * @param {Function} apiCall - Async function that makes the API call
 * @returns {Promise<any>} Result of the API call, or null if network error
 */
export const withNetworkErrorHandling = async (apiCall) => {
  try {
    return await apiCall();
  } catch (error) {
    if (isNetworkError(error)) {
      // Network errors are handled by useApiClient (shows offline dialog)
      // Return null to indicate failure without throwing
      return null;
    }
    throw error;
  }
};

export default withNetworkErrorHandling;
